export default "__VITE_ASSET__CbrT4M9g__"